import React from 'react';
import WhatsAppWorkflowDesigner from './WhatsAppWorkflowDesigner';

const WhatsAppWorkflowPage = () => {
  return (
    <div style={{ padding: 0 }}>
      <WhatsAppWorkflowDesigner />
    </div>
  );
};

export default WhatsAppWorkflowPage; 